<template>
    <a class="spacing back"
       data-ga=""
       @click="back">
        <b-icon-chevron-left class="back-left-icon"
                             v-if="direction==='left'" />返回
        <b-icon-chevron-right class="back-right-icon"
                              v-if="direction==='right'" />
    </a>
</template>

<script>
export default {
    name: 'Back',
    props: {
        direction: String,
        customBack: {
            default: false,
            type: Boolean
        }
    },
    methods: {
        back() {
            if (this.customBack) {
                this.$emit('callback');
            } else {
                this.$router.go(-1);
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.back {
    font-size: 16px;
    color: #999999;
    cursor: pointer;
    text-decoration: underline;
    .back-left-icon {
        position: relative;
        left: 2px;
    }
    .back-right-icon {
        position: relative;
        left: -2px;
    }
}
</style>
